/**
 * Splits up an array into sub arrays of the specified
 * @param {Object[]} array what to partition
 * @param {number} size length of partiion
 * @returns {Object[]}
 */
const partitionArray = (array, size) =>
    array.map((e, i) => (i % size === 0 ? array.slice(i, i + size) : null)).filter((e) => e);

module.exports = { partitionArray };
